  'use strict';

  var cfg = window.LMP_APP_CONFIG || {};
  var appMode = !!(cfg.standalone || cfg.previewMode);
  var nativeRoute = !!cfg.nativeRoute;
  var INSTALL_DELAY_MS = Number(cfg.installDelayMs || 15000);
  var deferredInstall = null;
  var installDelayElapsed = false;
  var installTimerStarted = false;
  var root = null;
  var toastTimer = null;

  var icons = {
    home:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 10.8 12 3l9 7.8"/><path d="M5.5 9.8V21h13V9.8"/><path d="M9.5 21v-6h5v6"/></svg>',
    grid:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="3" y="3" width="7" height="7" rx="2"/><rect x="14" y="3" width="7" height="7" rx="2"/><rect x="3" y="14" width="7" height="7" rx="2"/><rect x="14" y="14" width="7" height="7" rx="2"/></svg>',
    search:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>',
    user:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><circle cx="12" cy="8" r="4"/><path d="M4.5 21c.8-4 3.3-6 7.5-6s6.7 2 7.5 6"/></svg>',
    cart:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 1.9-1.4L21 8H7"/><circle cx="10" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>',
    heart:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M20.8 4.6a5.6 5.6 0 0 0-7.9 0L12 5.5l-.9-.9a5.6 5.6 0 0 0-7.9 7.9l.9.9L12 21l7.9-7.6.9-.9a5.6 5.6 0 0 0 0-7.9Z"/></svg>',
    back:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="m15 18-6-6 6-6"/></svg>',
    truck:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
    trash:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M4 7h16"/><path d="M9 7V4h6v3"/><path d="m7 7 1 13h8l1-13"/></svg>',
    plus:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 5v14M5 12h14"/></svg>',
    bag:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M5 8h14l-1 13H6L5 8Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/></svg>'
  };

  function esc(v){
    return String(v == null ? '' : v)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  function stripHtml(v){
    var d=document.createElement('div'); d.innerHTML=String(v||''); return d.textContent||d.innerText||'';
  }
  function normalizeImage(src){
    if(!src) return '';
    if(typeof src === 'object') src = src.src || src.url || '';
    src=String(src);
    return src.indexOf('//')===0 ? 'https:'+src : src;
  }
  function formatMoney(cents){
    cents=Number(cents||0);
    try{
      return new Intl.NumberFormat('fr-MA',{style:'currency',currency:'MAD',minimumFractionDigits:2}).format(cents/100).replace('MAD','MAD');
    }catch(e){return (cents/100).toFixed(2)+' MAD';}
  }
  function formatDecimal(value){
    var n=parseFloat(value||0);
    try{return new Intl.NumberFormat('fr-MA',{style:'currency',currency:'MAD',minimumFractionDigits:2}).format(n)}
    catch(e){return n.toFixed(2)+' MAD'}
  }
  function previewParams(){
    if(!cfg.previewMode) return '';
    var p=new URLSearchParams(location.search);
    var theme=p.get('preview_theme_id');
    var q=new URLSearchParams();
    if(theme) q.set('preview_theme_id',theme);
    q.set('lmp_app_preview','1');
    return q.toString();
  }
  function appUrl(path, extra){
    if(!cfg.previewMode) return path+(extra ? (path.indexOf('?')>-1?'&':'?')+extra : '');
    var p=new URLSearchParams(previewParams());
    if(extra){
      new URLSearchParams(extra).forEach(function(v,k){p.set(k,v)});
    }
    return path+'?'+p.toString();
  }
  function go(path, extra){ location.href=appUrl(path,extra); }

  function activeTab(){
    var p=location.pathname;
    if(p==='/cart') return 'cart';
    if(p==='/search') return 'search';
    if(p==='/pages/categories-parapharmacie'||p.indexOf('/collections/')===0||p==='/pages/marques') return 'categories';
    if(p.indexOf('/account')===0) return 'account';
    return 'home';
  }
  function navItem(path,label,ico,key){
    var active=activeTab()===key;
    var badge=key==='cart'?'<span class="lmp-nav-badge" data-lmp-cart-badge hidden></span>':'';
    return '<a href="'+esc(appUrl(path))+'" class="'+(active?'is-active':'')+'" data-lmp-link>'+icons[ico]+'<span>'+esc(label)+'</span>'+badge+'</a>';
  }
  function bottomNav(){
    return '<nav class="lmp-native-nav" aria-label="Navigation principale">'+
      navItem('/','Accueil','home','home')+
      navItem('/pages/categories-parapharmacie','Catégories','grid','categories')+
      navItem('/search','Recherche','search','search')+
      navItem('/account','Compte','user','account')+
      navItem('/cart','Panier','cart','cart')+
      '</nav>';
  }
  function shell(content){
    root=document.createElement('div');
    root.id='lmp-native-app';
    root.innerHTML='<div class="lmp-native-shell"><main class="lmp-native-scroll" id="lmp-native-scroll">'+content+'</main>'+bottomNav()+'</div>';
    document.body.appendChild(root);
    document.documentElement.classList.remove('lmp-native-route');
    refreshCartBadge();
  }
  function topbar(back){
    var brand='<div class="lmp-topbar__brand"><img class="lmp-logo" src="'+esc(cfg.logoUrl||'')+'" alt="La Maison Para"></div>';
    if(back) brand='<button class="lmp-icon-btn" type="button" data-lmp-back aria-label="Retour">'+icons.back+'</button>'+brand;
    return '<header class="lmp-topbar">'+brand+'<div class="lmp-topbar__actions">'+
      '<button class="lmp-icon-btn" type="button" data-lmp-search aria-label="Rechercher">'+icons.search+'</button>'+
      '<button class="lmp-icon-btn" type="button" data-lmp-cart aria-label="Panier">'+icons.cart+'<span class="lmp-cart-dot" data-lmp-cart-top hidden></span></button>'+
      '</div></header>';
  }
  function searchBox(value){
    return '<form class="lmp-search" data-lmp-search-form>'+icons.search+
      '<input type="search" name="q" value="'+esc(value||'')+'" autocomplete="off" enterkeyhint="search" placeholder="Rechercher un produit, une marque...">'+
      '</form>';
  }
  function categoryCards(large){
    var imgs=cfg.categoryImages||{};
    var cats=[
      ['Solaire','/collections/protections-solaires',imgs.solaire,'☀️'],
      ['Visage','/collections/visage',imgs.visage,'✨'],
      ['Cheveux','/collections/soins-cheveux',imgs.cheveux,'💆'],
      ['Corps','/collections/corps',imgs.corps,'🧴'],
      ['Hygiène & santé','/search','', '✚','q=Hygiène'],
      ['Marques','/pages/marques','', '🏷️']
    ];
    return '<div class="'+(large?'lmp-category-large':'lmp-cat-grid')+'">'+cats.map(function(c){
      var u=appUrl(c[1],c[4]||'');
      return '<a class="lmp-cat" href="'+esc(u)+'" data-lmp-link>'+
        (c[2]?'<img src="'+esc(c[2])+'" alt="" loading="lazy">':'<div class="lmp-cat__fallback" aria-hidden="true">'+c[3]+'</div>')+
        '<span>'+esc(c[0])+'</span></a>';
    }).join('')+'</div>';
  }
  function featuredData(){
    try{
      var el=document.getElementById('lmp-native-data');
      return el?JSON.parse(el.textContent||'{}').featured||[]:[];
    }catch(e){return []}
  }
  function productCard(p, decimal){
    var price=decimal?formatDecimal(p.price):formatMoney(p.price);
    var compare=p.compareAtPrice||p.compare_at_price||0;
    var compareText=compare&&(Number(compare)>Number(p.price)) ? '<span class="lmp-product-card__compare">'+(decimal?formatDecimal(compare):formatMoney(compare))+'</span>':'';
    return '<a class="lmp-product-card" href="'+esc(appUrl(p.url||('/products/'+p.handle)))+'" data-lmp-link>'+
      '<div class="lmp-product-card__media">'+(p.available===false?'<span class="lmp-badge">Rupture</span>':'')+
      (p.image?'<img src="'+esc(normalizeImage(p.image))+'" alt="" loading="lazy">':'')+'</div>'+
      '<div class="lmp-product-card__body"><div class="lmp-product-card__vendor">'+esc(p.vendor||'La Maison Para')+'</div>'+
      '<div class="lmp-product-card__title">'+esc(p.title||'Produit')+'</div><div class="lmp-product-card__price">'+price+compareText+'</div></div></a>';
  }
